export const INVALID_TOKEN_VIEW_STRINGS = {
  title: 'Invalid Reset Link',
  description:
    'The password reset link is invalid or has expired. Please request a new password reset.',
  requestNewResetButton: 'Request New Reset',
  backToLoginButton: 'Back to Login',
} as const
